/** Dates here are calendar dates in UTC: a tax point is a day, not an instant. */
export function formatTaxDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(iso));
}

/** `2026-10-01` for a DateInput from an ISO instant. */
export function toDateInput(iso: string | null | undefined): string {
  return iso ? iso.slice(0, 10) : '';
}

/** The ISO instant (UTC midnight) for a DateInput value. */
export function fromDateInput(value: string): string {
  return new Date(`${value}T00:00:00.000Z`).toISOString();
}

/** `23`, `9.975` — no trailing zeros, no float noise. */
export function formatRatePct(value: number): string {
  return `${Number(value.toFixed(4))}%`;
}

/** `Oct 1, 2026 →` for an open range, `Jan 1 – Sep 30, 2026` for a closed one. */
export function formatEffective(from: string, to: string | null): string {
  return to ? `${formatTaxDate(from)} – ${formatTaxDate(to)}` : `${formatTaxDate(from)} →`;
}

const regionNames =
  typeof Intl !== 'undefined' && 'DisplayNames' in Intl
    ? new Intl.DisplayNames(['en'], { type: 'region' })
    : null;

export function countryName(code: string): string {
  try {
    return regionNames?.of(code) ?? code;
  } catch {
    return code;
  }
}

/** ISO 3166-1 alpha-2 codes a tenant can register or tax in. */
export const COUNTRY_CODES =
  'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CD CF CG CH CI CK CL CM CN CO CR CU CV CW CY CZ DE DJ DK DM DO DZ EC EE EG ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(
    ' ',
  );

export const COUNTRY_OPTIONS = COUNTRY_CODES.map((code) => ({
  value: code,
  label: `${countryName(code)} (${code})`,
})).sort((a, b) => a.label.localeCompare(b.label));
